import React, { useEffect, useState } from 'react';

// import Perfil1 from '../../assets/img/perfil-4.png';
// import Perfil2 from '../../assets/img/perfil-5.png';
import Perfil3 from '../../assets/img/perfil-6.png';
// import Perfil4 from '../../assets/img/perfil-3.png';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationAlert } from '../../models/notifications.model';
import { General } from '../../services/general';
import { ProgramasService } from '../../services/programas.service';
import { Programa } from '../../models/programas.model';
import Select from 'react-select';
import { Pais } from '../../models/pais.model';
import { PaisesService } from '../../services/paises.service';
import { AxiosResponse } from 'axios';
import { ObrasService } from '../../services/obras.service';
import { ObraAppTemporal } from '../../models/obraAppTemporal.model';
import { ObraApp } from '../../models/obraApp.model';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '../shared/loading/Loading.component';

export default function Notification(props: any) {
    const moment = require('moment');
    const notificationsService = NotificationsService({ locale: 'en' });
    const [notifications, setNotifications] = useState<NotificationAlert[]>([]);
    const [programas, setProgramas] = useState<Programa[]>([]);
    const programService = ProgramasService({ locale: 'en' });
    const obrasService = ObrasService({ locale: 'en' });
    const paisesService = PaisesService({ locale: 'en' });
    const [paises, setPaises] = useState<Pais[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [countryId, setCountryId] = useState<number>();
    const [statusId, setStatusId] = useState<number>(0);
    const [selectedStatus, setSelectedStatus] = useState<any>({
        value: 0,
        label: 'Pendiente',
    });
    const [selectedCountry, setSelectedCountry] = useState<any>();
    const [modifiedBy, setModifiedBy] = useState<string>();
    const user = JSON.parse(localStorage.getItem('currentUsr')!);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const promisePaises = paisesService.getPaises();
        promisePaises.then((p: AxiosResponse) => {
            let items: Pais[] = [];
            items.push({ oid: null, nombre: 'All' });
            if (p.data) {
                items = items.concat(p.data);
            }
            setPaises(items);
        });
        const promiseProgram = programService.getProgramas();
        promiseProgram.then((response: any) => {
            const programs = response.data;
            setProgramas(programs);
            getNotifications(undefined, 0);
        });
        Promise.all([promiseProgram, promisePaises]).then((responseAll: any) => {
            setLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getNotifications = (countryId?: number, statusId?: number, modifiedBy?: string) => {
        setLoading(true);
        notificationsService
            .getNotifications({
                countryId: countryId,
                statusId: statusId,
                modifiedBy: modifiedBy,
            })
            .then((response: any) => {
                setNotifications(response.data);
                setLoading(false);
            });
    };

    const approveNotification = async (notification: NotificationAlert) => {
        if (notification.statusId === 0) {
            notification.statusId = 1;
            if (
                notification.notificationType === General.NotificationType.UpdateProjects ||
                notification.notificationType === General.NotificationType.CreateObra
            ) {
                notification.modifiedBy = user?.username;
                await notificationsService.updateNotification(notification);
                const obras = await obrasService.getObrasAppTemporales({
                    notificationId: notification.id,
                });
                await obrasService.saveObrasApp(
                    obras.data.map((unit: ObraAppTemporal) => {
                        const obra: ObraApp = {
                            oid: unit.oidObra,
                            actaSuspencionFirmada: unit.actaSuspencionFirmada,
                            cantidadManoObra: unit.cantidadManoObra,
                            cantidadObreroCesados: unit.cantidadObreroCesados,
                            estadoEjecucion: unit.estadoEjecucion,
                            estadoEjecucionItem: unit.estadoEjecucionItem,
                            fecha: unit.fecha,
                            fechaActualizacion: new Date(),
                            actaSuspencionMesFirma: unit.actaSuspencionMesFirma,
                            fechaFinalizacionEstimada: unit.fechaFinalizacionEstimada,
                            fechaFinalizacionVigente: unit.fechaFinalizacionVigente,
                            fechaInicio: unit.fechaInicio,
                            flexibilizacionClausulasContractuales:
                                unit.flexibilizacionClausulasContractuales,
                            jefeEquipo: unit.jefeEquipo,
                            jefeEquipoItem: unit.jefeEquipoItem,
                            latitud: unit.latitud,
                            gcrecord: unit.gcrecord,
                            limitacionActividadesAdministrativas:
                                unit.limitacionActividadesAdministrativas,
                            index: unit.index,
                            locked: unit.locked,
                            longitud: unit.longitud,
                            longitudKm: unit.longitudKm,
                            mesUltPagoContratista: unit.mesUltPagoContratista,
                            moneda: unit.moneda,
                            monedaItem: unit.monedaItem,
                            montoInicial: unit.montoInicial,
                            montoVigente: unit.montoVigente,
                            nombre: unit.nombre,
                            nota: unit.nota,
                            nuevoCronograma: unit.nuevoCronograma as string,
                            optimisticLockField: unit.optimisticLockField,
                            orden: unit.orden,
                            pagado: unit.pagado,
                            pagoStockMateriales: unit.pagoStockMateriales,
                            pais: unit.pais,
                            paisItem: unit.paisItem,
                            pendientePorVerificar: unit.pendientePorVerificar,
                            plazoInicialMeses: unit.plazoInicialMeses,
                            porcentajeBid: unit.porcentajeBid,
                            porcentajeContrapartida: unit.porcentajeContrapartida,
                            problemaCadenaSuministros: unit.problemaCadenaSuministros,
                            programItem: unit.programItem,
                            programa: unit.programa,
                            provincia: unit.provincia,
                            sobreCostoEstimado: unit.sobreCostoEstimado,
                            sobreCostoEstimadoNoMaterializado:
                                unit.sobreCostoEstimadoNoMaterializado,
                            seSuscribioAdenda: unit.seSuscribioAdenda,
                            tipoCambio: unit.tipoCambio,
                            tipoObra: unit.tipoObra,
                            tipoObraItem: unit.tipoObraItem,
                            tramo: unit.tramo,
                            rowClass: unit.rowClass,
                            anoFinalizaciónContrato: unit.anoFinalizaciónContrato,
                            apareceEnBaseDeDatos: unit.apareceEnBaseDeDatos,
                            avanceDePlazoPlazoIntermedio: unit.avanceDePlazoPlazoIntermedio,
                            clasificacionDeSobrecostos: unit.clasificacionDeSobrecostos,
                            clasificacionPorKm: unit.clasificacionPorKm,
                            clasificacionPorMontos: unit.clasificacionPorMontos,
                            clasificacionPorPlazo: unit.clasificacionPorPlazo,
                            clasificacionPorSobreplazo: unit.clasificacionPorSobreplazo,
                            contratista1: unit.contratista1,
                            contratista2: unit.contratista2,
                            contratistaConsorciosObra: unit.contratistaConsorciosObra,
                            desapareceDeBaseDeDatos: unit.desapareceDeBaseDeDatos,
                            empresaSupervisora: unit.empresaSupervisora,
                            estadoDeAvanceGeneral: unit.estadoDeAvanceGeneral,
                            externalIdCaptudata1: unit.externalIdCaptudata1,
                            externalIdcaptudata: unit.externalIdcaptudata,
                            f103: unit.f103,
                            fechaDeOrdenDeInicioEnMesAño: unit.fechaDeOrdenDeInicioEnMesAño,
                            fechaRecibioInformación: unit.fechaRecibioInformación,
                            ficConTazasCambioDiferenciadas: unit.ficConTazasCambioDiferenciadas,
                            ficmetodologicoContratosActivos: unit.ficmetodologicoContratosActivos,
                            ficmetodologicoContratosActivosSinCeros:
                                unit.ficmetodologicoContratosActivosSinCeros,
                            fpcmetodologicoContratosActivos: unit.fpcmetodologicoContratosActivos,
                            fpcmetodologicoContratosActivosSinCeros:
                                unit.fpcmetodologicoContratosActivosSinCeros,
                            localizacion: unit.localizacion,
                            manoObraPorMontoDeInversionMillones:
                                unit.manoObraPorMontoDeInversionMillones,
                            mesDelÚltimoPagoAlContratistaEnMesAño:
                                unit.mesDelÚltimoPagoAlContratistaEnMesAño,
                            montoContractualDolares: unit.montoContractualDolares,
                            montoContractualDolaresEnMillones:
                                unit.montoContractualDolaresEnMillones,
                            montoContractualInicialEnDólaresConTasaDeCambioPorMes:
                                unit.montoContractualInicialEnDólaresConTasaDeCambioPorMes,
                            montoContractualVigenteModificadoDolares:
                                unit.montoContractualVigenteModificadoDolares,
                            montoContractualVigenteModificadoDolaresEnMillones:
                                unit.montoContractualVigenteModificadoDolaresEnMillones,
                            montoContractualVigenteModificadoDólaresConTasaDeCam:
                                unit.montoContractualVigenteModificadoDólaresConTasaDeCam,
                            muestraDeChequeo: unit.muestraDeChequeo,
                            nacionalidadContratista: unit.nacionalidadContratista,
                            nacionalidadEmpresaSupervisora: unit.nacionalidadEmpresaSupervisora,
                            notaFinalEstadoGeneral: unit.notaFinalEstadoGeneral,
                            notaFinalSobrecostos: unit.notaFinalSobrecostos,
                            notaFinalSobreplazo: unit.notaFinalSobreplazo,
                            plazoContractualVigente: unit.plazoContractualVigente,
                            plazoContractualVigentePasoIntermedio:
                                unit.plazoContractualVigentePasoIntermedio,
                            plazoInicialPorKm: unit.plazoInicialPorKm,
                            plazoVigentePorKm: unit.plazoVigentePorKm,
                            ponderadorFicMca: unit.ponderadorFicMca,
                            ponderadorFicMcasinCeros: unit.ponderadorFicMcasinCeros,
                            ponderadorPfc: unit.ponderadorPfc,
                            ponderadorPfcMcasinCeros: unit.ponderadorPfcMcasinCeros,
                            porcentajeAvanceAcumulado: unit.porcentajeAvanceAcumulado,
                            porcentajeAvanceDePlazo: unit.porcentajeAvanceDePlazo,
                            precioInicialPorKmMillones: unit.precioInicialPorKmMillones,
                            precioVigentePorKmMillones: unit.precioVigentePorKmMillones,
                            sobrecostosMaterializados: unit.sobrecostosMaterializados,
                            sobrecostosUsd: unit.sobrecostosUsd,
                            sobrecostosUsdenMillones: unit.sobrecostosUsdenMillones,
                            sobreplazoMesesCalculado: unit.sobreplazoMesesCalculado,
                            subRegion: unit.subRegion,
                            supervisora1: unit.supervisora1,
                            tipoCambioPorMesYmoneda: unit.tipoCambioPorMesYmoneda,
                            tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras:
                                unit.tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras,
                            tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista:
                                unit.tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista,
                            totalPagoHastaLaFechaDolares: unit.totalPagoHastaLaFechaDolares,
                            _: unit._,
                            _2020: unit._2020,
                            _2021: unit._2021,
                            _2022: unit._2022,
                            _2023: unit._2023,
                            _2024: unit._2024,
                            _2025: unit._2025,
                        };
                        return obra;
                    })
                );
                getNotifications(countryId, statusId, modifiedBy);
                props.changeNotifications();
            } else if (
                notification.notificationType ===
                General.NotificationType.AssignProgramsAndCountriesUser
            ) {
                navigate('/admin-users');
            }
        }
    };

    const rejectNotification = async (notification: NotificationAlert) => {
        if (notification.statusId === 0) {
            notification.statusId = 2;
            notification.modifiedBy = user?.username;
            await notificationsService.updateNotification(notification);
            getNotifications(countryId, statusId, modifiedBy);
            props.changeNotifications();
        }
    };

    const getStatusString = (statusId: number) => {
        let statusName: string = '';
        if (statusId !== undefined) {
            const statusFilter = General.NotificationStatus.filter((s) => s.Id === statusId);
            if (statusFilter.length > 0) {
                statusName = statusFilter[0].Name;
            }
        }
        return statusName;
    };

    return (
        <section id='notification' className='bg-gray'>
            <div className='container'>
                <div className='row'>
                    <h2>Notificaciones</h2>
                </div>
            </div>
            <div className='container mt-3'>
                <div className='row'>
                    <div className='col-md-3'>
                        <span>
                            <b>Pais</b>
                        </span>
                        <Select
                            className='filter'
                            options={paises.map((item: any) => {
                                return {
                                    value: item.oid?.toString(),
                                    label: item.nombre,
                                };
                            })}
                            defaultValue={selectedCountry}
                            onChange={(e: any) => {
                                if (e.value) {
                                    const currentCountry = paises.filter(
                                        (s: Pais) => s.oid === parseInt(e.value)
                                    )[0];
                                    setSelectedCountry({
                                        value: currentCountry.oid,
                                        label: currentCountry.nombre,
                                    });
                                }
                                setCountryId(e.value);
                                getNotifications(e.value, statusId, modifiedBy);
                            }}
                        />
                    </div>
                    <div className='col-md-3'>
                        <span>
                            <b>Especialista</b>
                        </span>
                        <Select
                            className='filter'
                            options={[]}
                            onChange={(e: any) => {
                                setModifiedBy(e.value);
                                getNotifications(countryId, statusId, e.value);
                            }}
                        />
                    </div>
                    <div className='col-md-3'>
                        <span>
                            <b>Estado</b>
                        </span>
                        <Select
                            className='filter'
                            options={General.NotificationStatus.map((item: any) => {
                                return {
                                    value: item.Id?.toString(),
                                    label: item.Label,
                                };
                            })}
                            defaultValue={selectedStatus}
                            onChange={(e: any) => {
                                if (e.value) {
                                    setStatusId(e.value);
                                    const currentStatus = General.NotificationStatus.filter(
                                        (s) => s.Id === parseInt(e.value)
                                    )[0];
                                    setSelectedStatus({
                                        value: currentStatus.Id,
                                        label: currentStatus.Label,
                                    });
                                }
                                getNotifications(countryId, e.value, modifiedBy);
                            }}
                        />
                    </div>
                </div>

                {loading && (
                    <div className='loading'>
                        <Loading />
                    </div>
                )}

                {!loading && (
                    <div className='row'>
                        {notifications.map((notification: NotificationAlert) => {
                            return (
                                <React.Fragment>
                                    {(notification.notificationType ===
                                        General.NotificationType.UpdateProjects ||
                                        notification.notificationType ===
                                        General.NotificationType.CreateObra) && (
                                            <div className='col-12 col-md-4 mt-30'>
                                                <div className='cont-in d-flex alert'>
                                                    <div className='col-2'>
                                                        <img className='w-75' src={Perfil3} alt='' />
                                                    </div>
                                                    <div className='col-10'>
                                                        <span>
                                                            {moment(
                                                                notification.notificationDate
                                                            ).format('MM/DD/YYYY hh:MM A')}
                                                        </span>
                                                        {notification.notificationType ===
                                                            General.NotificationType.UpdateProjects ? (
                                                            <p>
                                                                Se acaba de hacer un cambio en{' '}
                                                                {programas &&
                                                                    programas.filter(
                                                                        (s) =>
                                                                            notification.programId &&
                                                                            s.oid &&
                                                                            s.oid ===
                                                                            notification.programId
                                                                    )[0].descripcion}{' '}
                                                                Y necesita aprobación <br />
                                                                <b>
                                                                    {' '}
                                                                    Estado:{' '}
                                                                    {getStatusString(
                                                                        notification.statusId as number
                                                                    )}
                                                                </b>
                                                            </p>
                                                        ) : (
                                                            <p>
                                                                Se acaba de crear una obra en{' '}
                                                                {programas &&
                                                                    programas.filter(
                                                                        (s) =>
                                                                            notification.programId &&
                                                                            s.oid &&
                                                                            s.oid ===
                                                                            notification.programId
                                                                    )[0].descripcion}{' '}
                                                                Y necesita aprobación <br />
                                                                <b>
                                                                    {' '}
                                                                    Estado:{' '}
                                                                    {getStatusString(
                                                                        notification.statusId as number
                                                                    )}
                                                                </b>
                                                            </p>
                                                        )}

                                                        <Link
                                                            className='nav-link'
                                                            to={`detailProgramNotification/${notification.id}`}>
                                                            Ver Detalles
                                                        </Link>
                                                        <React.Fragment>
                                                            <button
                                                                className='approved btn'
                                                                onClick={() => {
                                                                    approveNotification(notification);
                                                                }}
                                                                disabled={notification.statusId !== 0}>
                                                                Aprobar
                                                            </button>
                                                            <button
                                                                className='cancel btn'
                                                                onClick={() => {
                                                                    rejectNotification(notification);
                                                                }}
                                                                disabled={notification.statusId !== 0}>
                                                                Cancelar
                                                            </button>
                                                        </React.Fragment>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {notification.notificationType ===
                                        General.NotificationType.AssignProgramsAndCountriesUser && (
                                            <div className='col-12 col-md-4 mt-30'>
                                                <div className='cont-in d-flex alert'>
                                                    <div className='col-2'>
                                                        <img className='w-75' src={Perfil3} alt='' />
                                                    </div>
                                                    <div className='col-10'>
                                                        <span>
                                                            {moment(
                                                                notification.notificationDate
                                                            ).format('MM/DD/YYYY hh:MM A')}
                                                        </span>
                                                        <p>
                                                            <strong>
                                                                Asignar programas y paises al usuario{' '}
                                                                {notification.userNameAssignPrograms}
                                                            </strong>{' '}
                                                            <br />
                                                            <b>
                                                                {' '}
                                                                Estado:{' '}
                                                                {getStatusString(
                                                                    notification.statusId as number
                                                                )}
                                                            </b>
                                                        </p>
                                                        <Link className='nav-link' to='/admin-users'>
                                                            Ir a administracion usuarios
                                                        </Link>
                                                        <React.Fragment>
                                                            <button
                                                                className='approved btn'
                                                                onClick={() => {
                                                                    approveNotification(notification);
                                                                }}
                                                                disabled={notification.statusId !== 0}>
                                                                Asignar
                                                            </button>
                                                            <button
                                                                className='cancel btn'
                                                                onClick={() => {
                                                                    rejectNotification(notification);
                                                                }}
                                                                disabled={notification.statusId !== 0}>
                                                                Cancelar
                                                            </button>
                                                        </React.Fragment>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
}
